export const mpanelConfigDevelopment = {
    apiKey: "f4827103766d490eafa5b9f8bbe3caaf"
};

export const mpanelConfigProduction = {
    apiKey: "8f08b02d8cc1764dd701b05dba894ae4"
};
